import {fork, select} from "redux-saga/effects";
import {IApplicationState} from "../../index";
import {delay} from "redux-saga";
import {addNotFoundLocalizationKeys} from "../../../shared/i18n/trackNotFoundLocalizationKey";

export default function* trackLocalizationWorker() {
    const {synchronizationTimeout} = yield select(({ settings }: IApplicationState) => ({
        synchronizationTimeout: Math.max(5000, settings.general.synchronizationTimeout || 0)
    }));

    while (true) {
        yield delay(synchronizationTimeout);

        yield fork(addNotFoundLocalizationKeys);
    }
}